module.exports = "/static/assets/872031593c5ab3d019cd4df008f49816.png";